import {
  useHtzStructuralAssessmentCatalogShowActiveCatalogQuery,
  useHtzStructuralAssessmentCatalogShowQuery,
} from "@/services/backend/htz/inspection/api/structural-assessment-catalog-api";

/**
 * useActiveStructuralAssessmentCatalog loads the catalog of structural assessments which is active for the company.
 * The catalog is undefined while it loads or when the company has no active
 * catalog.
 */
export function useActiveStructuralAssessmentCatalog(companyId: string) {
  const {
    data: activeCatalog,
    isLoading: activeCatalogIsLoading,
    error: activeCatalogError,
  } = useHtzStructuralAssessmentCatalogShowActiveCatalogQuery(
    { companyId },
    { skip: !companyId },
  );

  const {
    data: catalog,
    isLoading: catalogIsLoading,
    error: catalogError,
  } = useHtzStructuralAssessmentCatalogShowQuery(
    { id: activeCatalog?.catalogId ?? "" },
    {
      skip: activeCatalog === undefined || activeCatalog.catalogId === null,
    },
  );

  return {
    data: catalog,
    isLoading: activeCatalogIsLoading || catalogIsLoading,
    error: activeCatalogError || catalogError,
  };
}
